import Cookies from 'js-cookie';
import { fromBase64, toBase64 } from './base64.js';
import LOG from '../logger.js';
const capitalizedFirst = (word) => {
    return word.charAt(0).toUpperCase() + word.slice(1);
};
export const UTM_PARAMS_COOKIE_NAME = 'CVENT_ANALYTICS_UTM_PROPS';
/**
 * Extracts UTM parameters from the URL. Fallback to reading from a cookie
 *
 * Note: This function is meant to be executed in the browser only as it relies on the document object to read the cookie that
 * is used to store the UTM parameters.
 *
 * @param url
 * @returns
 */
export const extractUTMParameters = (url) => {
    const result = {};
    const urlObj = new URL(url);
    const UTM_PREFIX = 'utm_';
    try {
        urlObj.searchParams.forEach((value, sParam) => {
            if (sParam.startsWith(UTM_PREFIX)) {
                let utmParam = sParam.substring(UTM_PREFIX.length);
                // utm_campaign represents the name
                if (utmParam === 'campaign') {
                    utmParam = 'name';
                }
                result[`utm${capitalizedFirst(utmParam)}`] = value;
            }
        });
        if (Object.keys(result).length > 0) {
            // Return the UTM parameters found in the URL
            return { type: 'url', props: result };
        }
        // We did not find the utm parameters in the URL, try to read from the cookie
        const utmEncryptedParams = Cookies.get(UTM_PARAMS_COOKIE_NAME);
        const utmDecrypted = utmEncryptedParams ? fromBase64(utmEncryptedParams) : null;
        return utmDecrypted
            ? {
                type: 'cookie',
                props: JSON.parse(utmDecrypted)
            }
            : { type: 'cookie', props: {} };
    }
    catch (e) {
        LOG.error('Error extracting UTM parameters', { url, error: e });
        return { type: 'cookie', props: {} };
    }
};
/**
 * Saves the UTM parameters in a cookie to share them with other apps
 * @param utmParams
 */
export const shareUTMParameters = (utmParams) => {
    if (typeof document !== 'undefined' && typeof window !== 'undefined') {
        const { hostname } = window.location;
        // we want to set the cookie on the top level domain (ie. .cvent.com)
        const domain = hostname === 'localhost' ? 'localhost' : `.${hostname.split('.').reverse()[1]}.${hostname.split('.').pop()}`;
        const utmEncrypted = toBase64(JSON.stringify(utmParams));
        Cookies.set(UTM_PARAMS_COOKIE_NAME, utmEncrypted, { domain });
    }
};
//# sourceMappingURL=utm.js.map